export var colors = {
    primary: '#00F0AA',
    primaryAlt: '#59bfa5',
    primaryAltTransparent: 'rgba(88, 199, 171, 0.51)',
    danger: '#EB5757',
    warning: '#F2994A',
    warning10: '#F2994A1A',
    action: '#07285B',
    smoke: '#979797',
    charcoal: '#353535',
    unSelected: '#E9E9E9',
    secondaryBackground: '#07285B',
    secondaryBackgroundAlt: '#395a71',
    onSecondaryBackgroundAlt: '#627989',
    onSecondaryBackground: '#FFFFFF',
    appexFontColor: '#07285b',
    appexFontDefault: '#1F1F1C',
    white: '#ffffff',
    defaultGreen: '#00F0AA',
    active: '#252525',
    inActive: '#C2C2C2',
    successBtn: '#27ae60',
    btnHover: '#f4f8fa',
    successBtnHover: '#f4fbf7',
    dark: '#000000',
    selected: '#828282',
    muted: '#828282',
    ios: '#828282',
    web: '#7F4AFF',
    android: '#36E0B7',
    selectedOption: '#F5F5F5',
};
export var sbColors = {
    white: '#FFFFFF',
    whiteSmoke: '#FAFAFA',
    whiteActive: '#F4F8FA',
    greyLight: '#EEEEEE',
    greyNeutral: '#E9E9E9',
    greyNormal: '#C2C2C2',
    greyMedium: '#BDBDBD',
    greyActive: '#828282',
    warningYellow: '#F2994A',
    warningYellow10: '#F2994A1A',
    pantone: '#F335357A',
    errorRed: '#EB5757',
    errorRed10: '#EB57571A',
    marine: '#07285B',
    blue: '#2D9CDB',
    jordyBlue: '#84AFE5',
    turquoise: '#1F9284',
    sundress: '#85C28B',
    mint: '#00F0AA',
    purple: '#7F4AFF',
    purple10: '#7F4AFF1A',
    default: '#252525',
    blackActive: '#353535',
    black: '#000000',
    black15: '#00000026',
};
